import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PaymentSubscriptionsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PaymentSubscriptions",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M21.2 13.94H4.09c-1.13-.02-2.06.88-2.09 2v9.39a2.03 2.03 0 0 0 2.07 2.01H21.2c1.12.02 2.04-.88 2.06-2v-9.39a2.04 2.04 0 0 0-2.06-2ZM3.3 15.95c0-.41.35-.73.75-.73H21.2c.41 0 .74.32.75.73v.95H3.3zm18.65 9.39c0 .41-.35.73-.75.73H4.09c-.41 0-.74-.32-.75-.73v-6.05h18.62v6.05Zm7.83-2.59-4.13 1.51a.32.32 0 0 1-.42-.19c-.02-.04-.02-.08-.02-.12v-4.18a.335.335 0 0 1 .51-.28l1.25.82c.68-1.33 1.04-2.8 1.03-4.29-.01-5.26-4.29-9.51-9.54-9.49-3.69 0-7.04 2.15-8.6 5.5H7.89c2.19-5.86 8.72-8.84 14.58-6.65a11.31 11.31 0 0 1 7.36 10.64c0 1.84-.45 3.66-1.32 5.28l1.33.86c.15.09.21.29.11.45-.04.07-.1.12-.18.14Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27.29 14.43c-.29 0-.58-.11-.81-.33l-3.43-3.43a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l2.62 2.62 2.62-2.62a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L28.1 14.1c-.22.22-.52.33-.81.33M19.29 29.29h-16c-1.89 0-3.43-1.54-3.43-3.43v-9.14c0-1.89 1.54-3.43 3.43-3.43h16c1.89 0 3.43 1.54 3.43 3.43v9.14c0 1.89-1.54 3.43-3.43 3.43m-16-13.72c-.63 0-1.14.51-1.14 1.14v9.14c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14v-9.14c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17 20.14H1a1.14 1.14 0 1 1 0-2.28h16a1.14 1.14 0 1 1 0 2.28M27.29 13.29c-.63 0-1.14-.51-1.14-1.14V8.72c0-2.52-2.05-4.57-4.57-4.57s-4.57 2.05-4.57 4.57a1.14 1.14 0 1 1-2.28 0c0-3.78 3.08-6.86 6.86-6.86s6.86 3.08 6.86 6.86v3.43c0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};
PaymentSubscriptionsIcon.displayName = 'PaymentSubscriptionsIcon';